// composables
import type { Ref } from 'vue'
// utilities
import Swal from 'sweetalert2'
// types
import type { Agreement } from '@/types/domain/agreement'

/**
 * Composable for managing agreement status changes
 * Handles status updates and archive prompts
 */
export default function useAgreementStatus(
  agreementData: Ref<Agreement | null>,
  updateAgreementData: (data: Record<string, unknown>) => Promise<unknown>
) {
  /**
   * Handles status change and prompts for archive if needed
   * @param status - The new status to set
   */
  async function statusChanged(status: string): Promise<void> {
    if (!status) {
      return
    }

    try {
      await updateAgreementData({ status: status })

      if (agreementData.value) {
        agreementData.value.status = status

        // Prompt for archive if status is a completion status
        if (status == 'Dealt' || status == 'Refinanced' || status == 'Settled' || status == 'Handed Back') {
          Swal.fire({
            title: 'Archive',
            text: 'Would you like to archive the customer?',
            icon: 'question',
            reverseButtons: true,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'var(--bg-brand-solid)',
            cancelButtonText: 'No',
            cancelButtonColor: 'var(--bg-secondary)'
          }).then(function (response) {
            if (response.isConfirmed && agreementData.value) {
              updateAgreementData({ isArchived: !agreementData.value.markers.archived })
              agreementData.value.markers.archived = !agreementData.value.markers.archived
            }
          })
        }
      }
    } catch (error) {
      // handle error
      console.error(error)
    }
  }

  return {
    // methods
    statusChanged
  }
}
